import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpSvc: HttpService) { }

  async createAdmin(userData: any) {
    try {
      const user = await this.httpSvc
        .post('/legal-entity/user', userData)
        .pipe(take(1))
        .toPromise();
      return user;
    } catch (error) {
      throw error;
    }

    // const asignUserCompany = await this.httpSvc
    //   .post('user/company', {
    //     userId: user._id,
    //     companyId: companyId,
    //   })
    //   .pipe(take(1))
    //   .toPromise()
    //   .catch((err) => {
    //     throw err;
    //   });
  }

  async editUser(id: string, data: any) {
    try {
      const user = await this.httpSvc
        .put(`/company/edit-consumer/${id}`, data)
        .pipe(take(1))
        .toPromise();
      return user;
    } catch (error) {
      throw error;
    }
  }

  async editAdmin(id: string, data: any) {
    try {
      const user = await this.httpSvc
        .put(`/legal-entity/user/${id}`, data)
        .pipe(take(1))
        .toPromise();
      return user;
    } catch (error) {
      throw error;
    }
  }

  async editUserCustomer(id: string, data: any) {
    try {
      const user = await this.httpSvc
        .put(`/user/customer/${id}`, data)
        .pipe(take(1))
        .toPromise();
      return user;
    } catch (error) {
      throw error;
    }
  }

  async MatrixAdmin(id: string, data: any) {
    try {
      const user = await this.httpSvc
        .put(`/user/administrator/${id}`, data)
        .pipe(take(1))
        .toPromise();
      return user;
    } catch (error) {
      throw error;
    }
  }

  async createCollaborator(userData: any, companyId: any) {
    const user = await this.httpSvc
      .post('/company/consumer', userData)
      .pipe(take(1))
      .toPromise()
      .catch((err) => {
        console.error('COLLABORATOR USER ASSIGNMENT: ', err);
        throw err;
      });
    return user;
  }

  async createEnterprise(
    userData: any,
    companyData: any,
    commercialBussiness?: any
  ) {
    companyData = {
      ...companyData,
      phone: 0,
      latitude: 0,
      longitude: 0,
      commercialBusiness: commercialBussiness,
      currency: {
        currency: 'CLP',
        currencyCode: 'CLP',
        currencySymbol: '$',
        decimals: 0,
        decimalSeparator: ',',
        thousandSeparator: '.',
        usePrefix: true,
        useSuffix: true,
      },
    };
    const company = await this.httpSvc
      .post('/company', companyData)
      .pipe(take(1))
      .toPromise();
    userData = {
      ...userData,
      companyId: company._id,
    };
    const user = await this.httpSvc
      .post('/user/create-administrator', userData)
      .pipe(take(1))
      .toPromise();

    return user;
  }

  async createBranch(branchData: any) {
    console.log("branch data: ", branchData);
    const branch = await this.httpSvc
      .post('/branch/create', branchData)
      .pipe(take(1))
      .toPromise()
      .catch((err) => {
        console.error('CUSTOMER COMPANY MANAGEMENT: ', err);
        throw err;
      });
    return branch;
  }

  getAdmins() {
    return this.httpSvc.get('/user/admins');
  }

  getCustomers() {
    return this.httpSvc.get('/user/customer');
  }

  getEnterprise(page?: number, limit?: number, search?: string, startDate?: string, endDate?: string,) {
    let filter = [];
    if (page) filter.push(`page=${page}`);
    if (limit) filter.push(`limit=${limit}`);
    if (search) filter.push(`search=${search}`);
    // if (sucursal) filter.push(`companyId=${sucursal}`);
    if (startDate) filter.push(`startDate=${startDate}`);
    if (endDate) filter.push(`endDate=${endDate}`);

    return this.httpSvc.get(`/company/companies?${filter.join('&')}`);
  }

  getUserConsumers() {
    return this.httpSvc.get('/user/consumer');
  }

  getCompanyConsumers(startDate?: string, endDate?: string) {
    let filter = [];
    if (startDate) filter.push(`startDate=${startDate}`);
    if (endDate) filter.push(`endDate=${endDate}`);
    return this.httpSvc.get(`/company/consumer?${filter.join('&')}`);
  }

  findOne(userId: string) {
    return this.httpSvc.get(`/user/${userId}`);
  }
  async findOneCompany(companyId: string) {
    try {
      return await this.httpSvc
        .get(`/company/${companyId}`)
        .pipe(take(1))
        .toPromise();
    } catch (error) {
      throw error;
    }
  }

  getConsumersByCompanyId(companyId?: string, limit?: number, page?: number, search?: string) {
    let filter = [];
    if (companyId) filter.push(`companyId=${companyId}`);
    if (search) filter.push(`search=${search}`);
    if (limit) filter.push(`limit=${limit}`);
    if (page) filter.push(`page=${page}`);
    return this.httpSvc.get(`/company/all-consumers?${filter.join('&')}`)
  }

  getConsumers(limit?: number, page?: number, companyId?: string, search?: string) {
    let filter = [];
    if (companyId) filter.push(`companyId=${companyId}`);
    if (search) filter.push(`search=${search}`);
    if (limit) filter.push(`limit=${limit}`);
    if (page) filter.push(`page=${page}`);
    return this.httpSvc.get(`/company/customer-search?${filter.join('&')}`)
  }

  getBranches(companyId?: string, limit?: number, page?: number, search?: string) {
    let filter = [];
    if (companyId) filter.push(`companyId=${companyId}`);
    if (search) filter.push(`search=${search}`);
    if (limit) filter.push(`limit=${limit}`);
    if (page) filter.push(`page=${page}`);
    return this.httpSvc.get(`/company/branches?${filter.join('&')}`)
  }

  branchesAssignFunds(companyId?: string, limit?: number, page?: number, search?: string) {
    let filter = [];
    if (companyId) filter.push(`companyId=${companyId}`);
    if (search) filter.push(`search=${search}`);
    if (limit) filter.push(`limit=${limit}`);
    if (page) filter.push(`page=${page}`);
    return this.httpSvc.get(`/company/branchesAssignFunds?${filter.join('&')}`)
  }
  getTransactionsByCompanyId(companyId?: string, startDate?: string, endDate?: string, limit?: number, page?: number, search?: string) {
    let filter = [];
    if (companyId) filter.push(`companyId=${companyId}`);
    if (search) filter.push(`search=${search}`);
    if (limit) filter.push(`limit=${limit}`);
    if (page) filter.push(`page=${page}`);
    if (startDate) filter.push(`startDate=${startDate} 00:00:00`);
    if (endDate) filter.push(`endDate=${endDate} 23:59:59`);
    return this.httpSvc.get(`/company/all-transactions?${filter.join('&')}`)
  }

  getBranchesByCompanyId(companyId?: string) {
    return this.httpSvc.get(`/company/my-branches?companyId=${companyId}`)
  }

  getCompany() {
    return this.httpSvc.get('/company');
  }

  getCompanyMetrics(rut: any) {
    return this.httpSvc.get('/analytics/performance', { rut });
  }

  changePassword(payload: any) {
    return this.httpSvc.put('/user/change-password', payload);
  }

  findMyCompany() {
    return this.httpSvc.get('/company');
  }

  uploadPhoto(photo: any, id: any) {
    return this.httpSvc.put(`/user/photo/${id}`, {
      photo: photo,
    });
  }

  recoverPassword(payload: any) {
    return this.httpSvc.post('/auth/recoverPassword', { email: payload.email });
  }

  recoverPasswordStep2(token: any, payload: any) {
    return this.httpSvc.post(
      `/auth/recovery-password/change-pasword/${token}`,
      { password: payload.newPassword }
    );
  }

  editBranchCompleteData(id: any, payload: any) {
    try {
      return this.httpSvc
        .put(`/branch/edit/${id}`, payload)
        .pipe(take(1))
        .toPromise();
    } catch (error) {
      throw error;
    }
  }

  //desactivar colaborador
  walletOn(id: any) {
    try {
      return this.httpSvc
        .patch(`/company/consumer/wallet-on/${id}`)
        .pipe(take(1))
        .toPromise();
    } catch (error) {
      throw error;
    }
  }
  walletOff(id: any) {
    try {
      return this.httpSvc
        .patch(`/company/consumer/wallet-off/${id}`)
        .pipe(take(1))
        .toPromise();
    } catch (error) {
      throw error;
    }
  }


  branchOn(id: any) {
    try {
      return this.httpSvc
        .patch(`/branch/branch-on/${id}`)
        .pipe(take(1))
        .toPromise();
    } catch (error) {
      throw error;
    }
  }

  branchOff(id: any) {
    try {
      return this.httpSvc
        .patch(`/branch/branch-off/${id}`)
        .pipe(take(1))
        .toPromise();
    } catch (error) {
      throw error;
    }
  }

  editBranchCreditLine(id: any, amount: any, hasLimit: any) {
    return this.httpSvc.put(`/branch/limit/${id}?amount=${amount}&limit=${hasLimit}`);
  }

  getUserPhoto(id: any) {
    return this.httpSvc.get(`/user/${id}`);
  }

  getAllBranchesReport(companyId?: string) {
    return this.httpSvc.get(`/report/branches/${companyId}`)
  }

  getCompaniesReport() {
    return this.httpSvc.get(`/report/companies`)
  }

  getDetailHistory(Id: string, limit?: number, page?: number) {
    let filter = [];
    if (limit) filter.push(`limit=${limit}`);
    if (page) filter.push(`page=${page}`);
    return this.httpSvc.get(`/company/consumer-details/${Id}?${filter.join('&')}`);
  }

  deleteCollaborator(id: string) {
    return this.httpSvc.delete(`/branch/delete-account/${id}`)
  }

  setLimit(payload: any) {
    return this.httpSvc.put(`/company/limit-branchs`, payload)
  }

}
